
export function Loading(props) {
    return (
        <div className="loading-panel">
            <span class="loader"></span>
        </div>
    )
}
